import fgInput from "./components/Inputs/formGroupInput.vue";
import Card from "./components/Cards/Card.vue";
import Button from "./components/Button.vue";
import { Input, InputNumber } from "element-ui";
import Stories from "./components/Stories.vue";
import StoryTagSelector from "./components/StoryTagSelector.vue";
import StoryAuthorSelector from "./components/StoryAuthorSelector.vue";
import StoryYoutubePlayer from "./components/StoryYoutubePlayer.vue";
import StoryPeertubePlayer from "./components/StoryPeertubePlayer.vue";
import StoryAudioPlayer from "./components/StoryAudioPlayer.vue";
import StoryPublication from "./pages/Stories/StoryPublication.vue";
import StoryAttachments from "./pages/Stories/StoryAttachments.vue";
import StoryRelated from "./pages/Stories/StoryRelated.vue";
import TagsList from "./components/TagsList.vue";
import TopicStories from "./components/TopicStories.vue";
import FluxEditor from "./components/FluxEditor.vue";

/**
 * You can register global components here and use them as a plugin in your main Vue instance
 */

const GlobalComponents = {
  install(Vue) {
    Vue.component("fg-input", fgInput);
    Vue.component("card", Card);
    Vue.component(Button.name, Button);
    Vue.component(Input.name, Input);
    Vue.component(InputNumber.name, InputNumber);
    Vue.component(Stories.name, Stories);
    Vue.component(StoryTagSelector.name, StoryTagSelector);
    Vue.component(StoryAuthorSelector.name, StoryAuthorSelector);
    Vue.component(StoryPublication.name, StoryPublication);
    Vue.component(StoryAttachments.name, StoryAttachments);
    Vue.component(StoryRelated.name, StoryRelated);
    Vue.component(TagsList.name, TagsList);
    Vue.component(FluxEditor.name, FluxEditor);
    Vue.component(StoryYoutubePlayer.name, StoryYoutubePlayer);
    Vue.component(StoryPeertubePlayer.name, StoryPeertubePlayer);
    Vue.component(StoryAudioPlayer.name, StoryAudioPlayer);
    Vue.component(TopicStories.name, TopicStories);
  },
};

export default GlobalComponents;
